<template lang="pug">
v-app
  app-page(title="Профиль" :showHeader="showHeader" :showFab="showHeader")
    v-layout(v-if="!sended")
      app-toolbar(:title="headerText")
                
    v-layout(v-if="!sended" align-start)
      v-flex(xs7 my-2 mr-6)
        v-tabs.tabs(v-model="tabs" grow color="transparent" height="35" centered slider-color="#00BCD4" active-class="tabs__item--active")
          v-tab.tabs__item.text-none Физическое лицо
          v-tab.tabs__item.text-none Юридическое лицо
      v-flex(xs5 mt-4 mr-0) 
          span(v-if="form.specialistGroup==null || form.specialistGroup.id==null") Банковские реквизиты
          
    v-form(v-if="!sended" ref="specRegisterForm" v-model="valid")
      v-layout(align-start)
        v-flex(xs7)
          .pt-4.sud-block-overlay.light
            app-select(v-model="form.specialistType" :items="specTypes" label="Специалист" item-text="title" :rules="[rules.required]")

            app-text-field(v-if="form.specialistType && form.specialistType.value==0" v-model="form.regNumber" label="Регистрационный номер в реестре адвокатов" :rules="[rules.required]")
            app-text-field(v-if="form.specialistType && form.specialistType.value==0" v-model="form.identityCardNumber" label="Номер удостоверения адвоката" :rules="[rules.required, rules.number]")
            app-text-field(v-if="form.specialistType && form.specialistType.value==0" v-model="form.identityCardData" label="Кем и когда выдано удостоверение" :rules="[rules.required]")
            
            v-tabs-items(v-model="tabs" light)
              // Individual
              v-tab-item
                app-text-field(v-model="form.persona.name" label="ФИО"  :rules="[rules.required]")
                app-date-picker(v-model="form.persona.birthDate" label="Дата рождения" view-format="DD.MM.YYYY")
            
              // Legal
              v-tab-item
                app-text-field(v-model="form.persona.orgName" label="Наименование"  :rules="[rules.required]")
                app-text-field(v-model="form.persona.orgINN" label="ИНН" :rules="[rules.required, rules.number]")
                app-text-field(v-model="form.persona.orgKPP" label="КПП" :rules="[rules.required, rules.number]")
                app-text-field(v-model="form.persona.name" label="ФИО представителя" :rules="[rules.required]")
            
            app-combobox(v-model="phoneItems" :items="phoneItems" item-text="data" label="Телефон" :rules="[rules.requiredcombo]")
            app-combobox(v-model="addressItems" :items="addressItems" item-text="data" label="Адрес" :rules="[rules.requiredcombo]")

          .pt-4.sud-block-overlay.light.mt-4.mr-6
            app-select(v-model="form.specialistGroup" :items="preparedGroups" label="Группа" item-text="groupName")
            app-text-field(v-model="form.email" label="Email" :rules="[rules.email]")
            app-text-field(v-if="!currentSpec" v-model="form.passwd" label="Пароль" :rules="[rules.required]")
            app-textarea(v-model="form.persona.personaComments[0].comment" label="Комментарий")

          .pt-4.text-right.mr-6
            app-button-action.mr-5(v-if="readyToApprove" @click="approveSpec") Принять
            app-button-action(@click="createSpec" :disabled="!valid") {{confirmText}}
        
        v-flex(xs5)
          .pt-4.mr-0.sud-block-overlay.light(v-if="form.specialistGroup==null || form.specialistGroup.id==null")
            bankAccountItem(:form.sync="form.bankAccount")


    v-layout(v-if="sended")
      app-toolbar(:title="successText")

</template>

<script>
import { AppDialogToggable } from '@/components'
import { mapGetters } from 'vuex'
import { $_validate_rules } from '@/common/ValidateRules'
import moment from 'moment'

import bankAccountItem from './components/BankAccountItem'

import {mask} from 'vue-the-mask'

export default {
  mixins: [AppDialogToggable, $_validate_rules],
  directives: {mask},
  components: {
    bankAccountItem
  },
  props: {
    specId: null,
  },
  data () {
    const defaultForm = Object.freeze({
      passwd: '',
      id: null,
      bankAccount: {},
      regNumber: '',
      identityCardNumber: '',
      identityCardData: '',
      specialistType: null,
      specialistGroup: null,
      persona: { 
        name: '',
        birthDate: moment().format('YYYY-MM-DD'),
        orgName: '',
        orgINN: '',
        orgKPP: '',
        personaData: [],
        personaComments: [
          {comment: ''}
        ],
        personaType: {
          name: 'FL'
        },
      },
    })

    return {
      valid: false,
      mask: {
        phone: '+7 (###) ### ####',
      },
      sended: false,
      specTypes: [{value: 0, title:'Адвокат'}, {value: 1, title:'Переводчик'}],
      specStatuses:[],
      form: Object.assign({}, defaultForm),
      defaultForm,
      tabs: 0,
      emailItems: [],
      phoneItems: [],
      addressItems: [],
      comments: '',
      sendedResult: ''
    }
  },
  mounted() {
    this.$store.dispatch('specialist/LOAD_GROUPS')
    if(this.$route.name=='SpecialistProfile') 
        this.$store.dispatch('specialist/LOAD_CURRENT_SPEC').then(() => this.updateForm())
    if(this.$route.name=='SpecialistEditProfile') 
        this.$store.dispatch('specialist/LOAD_SPEC', { specId: this.specId }).then(() => this.updateForm())
  },
  methods: {
    createSpec() {
      if (this.$refs.specRegisterForm.validate()) {
          let otherData = this.form.persona.personaData.filter(obj => obj.dataType.name !== 'ADDRESS' && obj.dataType.name !== 'EMAIL' && obj.dataType.name !== 'PHONE')
          this.form.persona.personaData = otherData.concat(this.emailsData, this.addressesData, this.phonesData)
          this.form.persona.personaType = this.form.persona.personaType.name
          this.form.persona.birthDate = moment(this.form.persona.birthDate).format('YYYY-MM-DD HH:mm')
          
          if(this.form.specialistGroup && this.form.specialistGroup.id==null) this.form.specialistGroup=null
          
          if(this.currentSpec==null)
            this.$store.dispatch('specialist/CREATE_SPEC', this.form)
            .then(data => {
                this.sended=true
                if (data.status == 'exist')
                  this.sendedResult = 'Внимание! Пользователь с такими данными уже зарегистрирован в системе.';
                else if (data.status == 'error')
                  this.sendedResult = 'Внимание! При регистрации возникла ошибка.';
                else 
                  this.sendedResult = 'Регистрация прошла успешно. На указанный адрес электронной почты отправлено письмо для подтверждения аккаунта.';
             })
            .catch(() => {
                this.sended=true
                this.sendedResult = 'Внимание! При регистрации возникла ошибка.';
            })
          else {
            if(this.$route.name=='SpecialistEditProfile'){
                this.$store.dispatch('specialist/EDIT_SPEC', this.form)
                .then(() => this.sended=true)
                .catch(() => this.sended=false)
            } else {
                this.$store.dispatch('specialist/UPDATE_PROFILE', this.form)
                .then(() => this.sended=true)
                .catch(() => this.sended=false)
            }
          }
      }
    },
    updateForm() {
      let baseObj = this.currentSpec || this.defaultForm
      this.form = JSON.parse(JSON.stringify(baseObj))
      let personData = this.form.persona.personaData
      this.phoneItems = personData.filter(item => item.dataType.name === 'PHONE')
      this.emailItems = personData.filter(item => item.dataType.name === 'EMAIL')
      this.addressItems = personData.filter(item => item.dataType.name === 'ADDRESS')
      if(this.form.persona.personaComments.length==0) this.form.persona.personaComments = [{ comment: '', id: null }]
    },
    approveSpec() {
      this.$store.dispatch('specialist/APPROVE_SPEC', { specId: this.specId })
      .then(() => this.$router.push({ path: `/specialist/list` }))
    },
  },
  computed: {
    ...mapGetters('specialist', ['groups','isGroupsLoaded', 'currentSpec']),
    isNotReady () {
      return false
    },
    showHeader() {
      return this.currentSpec!=null ? true : false
    },
    confirmText() {
      return this.currentSpec!=null ? "Редактировать" : "Зарегистрировать"
    },
    headerText() {
      return this.currentSpec!=null ? "Редактировать профиль специалиста" : "Зарегистрировать специалиста"
    },
    successText() {
      return this.$route.name!='SpecialistRegister' ? "Профиль успешно обновлен" : this.sendedResult
    },
    readyToApprove() {
      return (this.$route.name=='SpecialistEditProfile' && this.currentSpec!=null && !this.currentSpec.moderated)
    },

    preparedGroups() {
      let list = [{ groupName: 'Не состоит', id: null }]
      for (let i = 0; i < this.groups.length; i++) list.push(this.groups[i]) 
      return list
    },
    emailsData () {
      return this.emailItems.map(item => (item instanceof Object) ? item : { data: item, dataType: 'EMAIL' })
    },

    phonesData () {
      return this.phoneItems.map(item => (item instanceof Object) ? item : { data: item, dataType: 'PHONE' })
    },

    addressesData () {
      return this.addressItems.map(item => (item instanceof Object) ? item : { data: item, dataType: 'ADDRESS' })
    },
  }
}
</script>

<style lang="scss" scoped>

.light {
  background-color: #ffffff;
}

.tabs__item--active {
  color: #00BCD4 !important;
}

.tabs__item {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
}

</style>

